import axios from '../axios/index';

// const url = 'http://127.0.0.1:7012';
const url = 'https://ecogreenweb.icangjiang.com';

//登录
export const ajax_login = (username,password) => axios.post(url+'/login',{
    username,
    password
});

//退出
export const ajax_logout = () => axios.get(url+'/logout');

//修改密码
export const change_pwd = (formData) => axios.post(url+'/change_pwd',formData);

//文章列表
export const singleList = (page,formData) => axios.get(url+'/single/'+page,formData);
//创建文章
export const singleCreate = (formData) => axios.post(url+'/single/create',formData);
//修改文章
export const singleUpdate = (id,formData) => axios.post(url+'/single/update/'+id,formData);
//删除文章
export const singleDel = (id) => axios.post(url+'/single/delete/'+id);
//文章明细
export const singleDetail = (id) => axios.get(url+'/single/detail/'+id);

//获取用户列表
export const userList = (formData) => axios.post(url+'/admin/list',formData);
//新增用户
export const userCreate = (formData) => axios.post(url+'/admin/create',formData);
//修改用户信息
export const userUpdate = (formData) => axios.post(url+'/admin/update',formData);
//删除用户
export const userDelete = (formData) => axios.post(url+'/admin/delete',formData);
//修改密码
export const userUpdate_pwd = (formData) => axios.post(url+'/admin/update_pwd',formData);

//获取角色列表
export const roleList = (formData) => axios.post(url+'/role/list',formData);
//新增角色
export const roleCreate = (formData) => axios.post(url+'/role/create',formData);
//修改角色信息
export const roleUpdate = (formData) => axios.post(url+'/role/update',formData);
//删除角色
export const roleDelete = (formData) => axios.post(url+'/role/delete',formData);
//为角色分配权限
export const roleAccess = (formData) => axios.post(url+'/role/access',formData);
//获取角色权限列表
export const getAccessLists = (formData) => axios.post(url+'/role/getAccessLists',formData);

//获取菜单列表
export const menuList = (formData) => axios.post(url+'/menu/list',formData);
//新增菜单
export const menuCreate = (formData) => axios.post(url+'/menu/create',formData);
//修改菜单
export const menuUpdate = (formData) => axios.post(url+'/menu/update',formData);
//删除菜单
export const menuDelete = (formData) => axios.post(url+'/menu/delete',formData);

//获取栏目列表
export const columnList = (formData) => axios.post(url+'/column/list',formData);
//新增栏目
export const columnCreate = (formData) => axios.post(url+'/column/create',formData);
//修改栏目
export const columnUpdate = (formData) => axios.post(url+'/column/update',formData);
//删除栏目
export const columnDelete = (formData) => axios.post(url+'/column/delete',formData);

//新闻&产品列表
export const contentList = (page,formData) => axios.get(url+'/content/'+page,formData);
//创建新闻&产品
export const contentCreate = (formData) => axios.post(url+'/content/create',formData);
//修改新闻&产品
export const contentUpdate = (id,formData) => axios.post(url+'/content/update/'+id,formData);
//删除新闻&产品
export const contentDel = (id) => axios.post(url+'/content/delete/'+id);
//新闻&产品明细
export const contentDetail = (id) => axios.get(url+'/content/detail/'+id);

//广告列表
export const adList = (page,formData) => axios.get(url+'/ad/'+page,formData);
//创建广告
export const adCreate = (formData) => axios.post(url+'/ad/create',formData);
//修改广告
export const adUpdate = (id,formData) => axios.post(url+'/ad/update/'+id,formData);
//删除广告
export const adDel = (id) => axios.post(url+'/ad/delete/'+id);

//删除图片
export const upyunDel = (formData) => axios.post(url+'/upload/upyunDel',formData);

//留言列表
export const messageList = (page,formData) => axios.get(url+'/message/'+page,formData);
//删除留言
export const messageDel = (id) => axios.post(url+'/message/delete/'+id);

// 站点地图
export const sitemapCreate = (formData) => axios.get(url+'/sitemap/create',formData);

// seo
export const seoDetail = (id) => axios.get(url+'/seo/detail/'+id);
export const seoUpdate = (id,formData) => axios.post(url+'/seo/update/'+id,formData);

